import i18n from '@/plugins/i18n';
export const getApmNavTabs = () => [
  {
    name: i18n.global.t('dashboard'),
    path: 'dashboard',
    fullPath: '/apm/dashboard/',
    dashboardTab: [
      {
        tabName: i18n.global.t('application'),
        routerName: 'service',
      },

      {
        tabName: i18n.global.t('endpoint'),
        routerName: 'endpoint',
      },
      {
        tabName: i18n.global.t('alert.Instance'),
        routerName: 'instance',
      },
      {
        tabName: i18n.global.t('alert.database'),
        routerName: 'appdb',
        child: {
          childTab: [
            {
              tabName: i18n.global.t('overall'),
              routerName: 'overall',
            },
            {
              tabName: i18n.global.t('log.query'),
              routerName: 'query',
            },
          ],
        },
      },
      {
        tabName: i18n.global.t('infrastructure'),
        routerName: 'infra',
      },
    ],
  },
  {
    name: i18n.global.t('apm.topology-label'),
    path: 'topology',
    fullPath: '/apm/topology',
  },
  {
    name: i18n.global.t('trace.trace'),
    path: 'trace',
    fullPath: '/apm/trace',
  },
  // {
  //   name: 'Profile',
  //   path: 'profile',
  //   fullPath: '/apm/profile'
  // }
];

const apm = {
  key: 'apm',
  name: 'APM',
  icon: 'apm',
  navTabs: getApmNavTabs(),
};
export default apm;
